class DefaultAppStore {
    // AppStateType properties with default values
    lastTenant = null;
    tenant = null;
    user = null;
    curOrder = null;
    curUnpaidOrders = [];
    curPayOptions = {};
    cashRegister = null;
    terminal = null;
    pendingCardPayment = null;
    cardSettlement = { lastSettledAt: null, unsettledPayments: false };
    pendingOrderData = null;
    pausedOrderData = null;
    curGuest = 0;
    appConfig = null;
    printConfig = null;
    isOnline = true;
    localConnection = {
        connected: false,
        isServer: false,
        serverAddress: null,
        serverPort: null,
        terminals: []
    };
    device = null;
    syncStatus = 'done';
    syncOptions = {};
    workingDays = [];
    impersonate = false;
    trainingMode = false;
    tableMode = null;
    splitReceipt = { active: false, data: [] };
    curPricelist = 0;
    curDiscountPercent = 0;
    modules = {};
    integrations = {};
    ordersHubActive = false;
    locale = null;
    isRetail = false;
    lockedReason = null;
    kdsSettings = {
        itemsPerPage: [4, 6],
        fontSize: 'medium',
        yellowTimer: 300,
        redTimer: 600,
        filterForUser: false
    };
    activeSector = 0;
    darkTheme = null;
    redirect = false;
    debugMode = false;
    log = [];
    // AppGettersType
    get unpaidOrders() {
        return this.curUnpaidOrders;
    }
    // Required $patch method
    $patch(state) {
        Object.assign(this, state);
    }
}
export const defaultAppStore = new DefaultAppStore();
//# sourceMappingURL=DefaultAppStore.js.map